import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import CallEnd from '@material-ui/icons/CallEnd';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function EndCallButton(props: any) {
  const classes = useStyles();
  const { room } = useVideoContext();

  return (
    <Tooltip title={'End Call'} onClick={() => {
      window.sessionStorage.removeItem("twilioToken");
      if(props && props.endCall){
        props.endCall();
      }else{
        window.location.replace('/thank-you');
      }
      room.disconnect()
      }} placement="top" PopperProps={{ disablePortal: true }}>
      <Fab className={classes.fab} color="primary">
        <CallEnd style={{ color: "white" }}  />
      </Fab>
    </Tooltip>
  );
}
